const BLOCK_TAG = /<(p|br|div|ul|ol|li|h[1-6])[\s>/]/i;

/**
 * Třídnice activities used to be plain text (newlines); the rich editor stores HTML. Text without block-level tags is
 * treated as legacy plain text and its newlines become <br>, so it keeps its line breaks in the editor and in previews.
 */
export function toEditorHtml(value: string | null | undefined): string {
  if (!value) return '';
  return BLOCK_TAG.test(value) ? value : value.replace(/\r?\n/g, '<br>');
}

/** True when the editor HTML has no visible text (e.g. "<br>" or "<p>&nbsp;</p>" left after deleting everything). */
export function isBlankHtml(value: string | null | undefined): boolean {
  if (!value) return true;
  return !value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|\u00a0/g, '')
    .trim();
}

const TRAILING_BLOCK_CLOSE = /(?:<\/(?:p|div|li)>\s*)+$/i;

/**
 * Appends dictated plain text to editor HTML: escaped, and inside the last paragraph when the HTML ends with one,
 * so the text continues where the teacher stopped writing.
 */
export function appendPlainText(html: string | null | undefined, text: string): string {
  const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  if (isBlankHtml(html)) return escaped.trimStart();
  const value = html as string;
  const closing = value.match(TRAILING_BLOCK_CLOSE);
  const head = closing ? value.slice(0, closing.index) : value;
  const tail = closing ? closing[0] : '';
  const separator = /\s$/.test(head.replace(/<[^>]*>/g, '')) || /^\s/.test(text) ? '' : ' ';
  return head + separator + escaped + tail;
}
